export default __webpack_public_path__ + "static/media/certificado.9eaecc5f.svg";